export const fieldsMapDosageUnity = {
    ocorrenciaNo: { name: 'dosageUnityId', type: 'number' },
    V_103247: { name: 'dosageUnityId', type: 'number' },
    V_103248: { name: 'name', type: 'string' },
    V_103249: { name: 'habilitado', type: 'boolean' },
};
